import { createSlice } from '@reduxjs/toolkit';

export const footerSlice = createSlice({
  name: 'navbar',
  initialState: {
    height: 0,
  },
  reducers: {
    setFooterHeight: (state, action) => {
      state.height = action.payload;
    },
  },
});

export const { setFooterHeight } = footerSlice.actions;

export default footerSlice.reducer